/**
 * @generated SignedSource<<72a3ad3bfa03ffce6d353ee8d8741220>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type getMasterChartOfAccountQuery$variables = {
  id: number;
};
export type getMasterChartOfAccountQuery$data = {
  readonly sys_organization_master_chart_of_accounts: ReadonlyArray<{
    readonly chart_of_accounts_name: string;
    readonly master_chart_of_account_id: number;
    readonly organization: {
      readonly organization_label: string;
    };
    readonly updated_at_datetime: string;
  }>;
};
export type getMasterChartOfAccountQuery = {
  response: getMasterChartOfAccountQuery$data;
  variables: getMasterChartOfAccountQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "_eq",
                "variableName": "id"
              }
            ],
            "kind": "ObjectValue",
            "name": "master_chart_of_account_id"
          }
        ],
        "kind": "ObjectValue",
        "name": "where"
      }
    ],
    "concreteType": "sys_organization_master_chart_of_accounts",
    "kind": "LinkedField",
    "name": "sys_organization_master_chart_of_accounts",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "master_chart_of_account_id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "chart_of_accounts_name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updated_at_datetime",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "sys_organizations",
        "kind": "LinkedField",
        "name": "organization",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "organization_label",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "getMasterChartOfAccountQuery",
    "selections": (v1/*: any*/),
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "getMasterChartOfAccountQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fef798dac21873794bf533ce21afc1ad",
    "id": null,
    "metadata": {},
    "name": "getMasterChartOfAccountQuery",
    "operationKind": "query",
    "text": "query getMasterChartOfAccountQuery(\n  $id: Int!\n) {\n  sys_organization_master_chart_of_accounts(where: {master_chart_of_account_id: {_eq: $id}}) {\n    master_chart_of_account_id\n    chart_of_accounts_name\n    updated_at_datetime\n    organization {\n      organization_label\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "976f1ffb6546a2c79cef3872cb06e121";

export default node;
